export interface RecorderStartParams {
  liverId: string
  liverName?: string | null
}

export type RecorderLaunchResult = 'local' | 'protocol'

const localRecorderBaseUrl = 'http://127.0.0.1:17645/start'

export function buildRecorderStartUrl({ liverId, liverName }: RecorderStartParams): string {
  const url = new URL('logmane-recorder://start')
  url.searchParams.set('liverId', liverId)
  const trimmedName = liverName?.trim()
  if (trimmedName) {
    url.searchParams.set('liverName', trimmedName)
  }
  return url.toString()
}

export function buildLocalRecorderStartUrl({ liverId, liverName }: RecorderStartParams): string {
  const url = new URL(localRecorderBaseUrl)
  url.searchParams.set('liverId', liverId)
  const trimmedName = liverName?.trim()
  if (trimmedName) {
    url.searchParams.set('liverName', trimmedName)
  }
  return url.toString()
}

async function notifyRunningRecorder(params: RecorderStartParams): Promise<boolean> {
  const controller = new AbortController()
  const timeout = window.setTimeout(() => controller.abort(), 700)
  try {
    const resp = await fetch(buildLocalRecorderStartUrl(params), {
      cache: 'no-store',
      mode: 'cors',
      signal: controller.signal
    })
    return resp.ok
  } catch {
    return false
  } finally {
    window.clearTimeout(timeout)
  }
}

export async function openRecorderForLiver(params: RecorderStartParams): Promise<RecorderLaunchResult> {
  if (await notifyRunningRecorder(params)) {
    return 'local'
  }

  window.location.href = buildRecorderStartUrl(params)
  return 'protocol'
}
